var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpcCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6658_517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14062 3.89014V1.83936",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8125 3.89014V1.83936",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98438 10.7261H27.9609",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29688 14.8276C1.29688 9.67164 1.29687 7.09366 2.89863 5.49189C4.5004 3.89014 7.07838 3.89014 12.2344 3.89014H17.7031C22.8591 3.89014 25.4372 3.89014 27.0388 5.49189C28.6406 7.09366 28.6406 9.67164 28.6406 14.8276V17.562C28.6406 22.7179 28.6406 25.2961 27.0388 26.8977C25.4372 28.4995 22.8591 28.4995 17.7031 28.4995H12.2344C7.07838 28.4995 4.5004 28.4995 2.89863 26.8977C1.29687 25.2961 1.29688 22.7179 1.29688 17.562V14.8276Z",
    stroke: "#EA7F4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1719 21.6636C23.1719 22.4187 22.5598 23.0308 21.8047 23.0308C21.0496 23.0308 20.4375 22.4187 20.4375 21.6636C20.4375 20.9085 21.0496 20.2964 21.8047 20.2964C22.5598 20.2964 23.1719 20.9085 23.1719 21.6636Z",
    fill: "#EA7F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1719 16.1948C23.1719 16.9499 22.5598 17.562 21.8047 17.562C21.0496 17.562 20.4375 16.9499 20.4375 16.1948C20.4375 15.4397 21.0496 14.8276 21.8047 14.8276C22.5598 14.8276 23.1719 15.4397 23.1719 16.1948Z",
    fill: "#EA7F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3437 21.6636C16.3437 22.4187 15.7317 23.0308 14.9766 23.0308C14.2215 23.0308 13.6094 22.4187 13.6094 21.6636C13.6094 20.9085 14.2215 20.2964 14.9766 20.2964C15.7317 20.2964 16.3437 20.9085 16.3437 21.6636Z",
    fill: "#EA7F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3437 16.1948C16.3437 16.9499 15.7317 17.562 14.9766 17.562C14.2215 17.562 13.6094 16.9499 13.6094 16.1948C13.6094 15.4397 14.2215 14.8276 14.9766 14.8276C15.7317 14.8276 16.3437 15.4397 16.3437 16.1948Z",
    fill: "#EA7F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 21.6636C9.50001 22.4187 8.88788 23.0308 8.13281 23.0308C7.37774 23.0308 6.76562 22.4187 6.76562 21.6636C6.76562 20.9085 7.37774 20.2964 8.13281 20.2964C8.88788 20.2964 9.50001 20.9085 9.50001 21.6636Z",
    fill: "#EA7F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 16.1948C9.50001 16.9499 8.88788 17.562 8.13281 17.562C7.37774 17.562 6.76562 16.9499 6.76562 16.1948C6.76562 15.4397 7.37774 14.8276 8.13281 14.8276C8.88788 14.8276 9.50001 15.4397 9.50001 16.1948Z",
    fill: "#EA7F4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6658_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpcCalendar);
export default __webpack_public_path__ + "static/media/cpc-calendar.ed6e863bba62f1021b70acfef669a216.svg";
export { ForwardRef as ReactComponent };